
/**
 * Calcule la taille diagonale nécessaire pour le canvas (évite les bords coupés lors de la rotation)
 */
export function getDiagonalCanvasSize(video) {
    if (!video.videoWidth || !video.videoHeight) return 0;
    const margin = 10;
    const frameW = video.videoWidth + margin * 2;
    const frameH = video.videoHeight + margin * 2;
    return Math.ceil(Math.sqrt(frameW ** 2 + frameH ** 2));
}

/**
 * Calcule l'interpolation entre deux angles pour un mouvement fluide
 */
export function interpolateAngle(from, to, factor) {
    let diff = ((to - from + 540) % 360) - 180;
    return from + diff * factor;
}

/**
 * Gère le dessin de la vidéo sur le Canvas avec rotation adaptative
 */
export function renderVideoToCanvas(ctx, video, canvas, rotation, isFullscreen, isVideoVisible = true) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (!isVideoVisible) {
        return;
    }

    const vw = video.videoWidth;
    const vh = video.videoHeight;
    if (!vw || !vh || !canvas.width || !canvas.height) return;

    const margin = 8;
    const rad = (rotation * Math.PI) / 180;
    const cos = Math.abs(Math.cos(rad));
    const sin = Math.abs(Math.sin(rad));

    // Dimensions de la boîte englobante de la vidéo tournée (avec marge)
    const totalW = vw + margin * 2;
    const totalH = vh + margin * 2;
    const boundingW = totalW * cos + totalH * sin;
    const boundingH = totalW * sin + totalH * cos;

    // Calcul de l'échelle pour épouser parfaitement le conteneur disponible
    // sans jamais déborder ni passer derrière les barres de navigation
    const padding = 12;
    const availW = Math.max(10, canvas.width - padding * 2);
    const availH = Math.max(10, canvas.height - padding * 2);
    const scale = Math.min(availW / boundingW, availH / boundingH);

    ctx.save();
    
    // Centrage et mise à l'échelle
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.scale(scale, scale);
    ctx.rotate(rad);

    // Dessin de la vidéo
    ctx.drawImage(video, -vw / 2, -vh / 2);

    // Dessin de la bordure
    ctx.lineWidth = Math.max(2, 6 / scale);
    ctx.strokeStyle = "#000000";
    ctx.strokeRect(-vw / 2 - margin / 2, -vh / 2 - margin / 2, vw + margin, vh + margin);
    
    ctx.restore();
}
